import { Typography } from "@shared/ui.primitives";
import React from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "variationName">;
};

export const VerticalProductCardVariationName: React.FC<Props> = ({
  product
}) => {
  if (!product.variationName) return null;
  return (
    <Typography colour="primary-light" variant="smallprint-md">
      {product.variationName}
    </Typography>
  );
};
